import React from 'react';
import { Block, Icon } from '@/presentation/components';
import { GoToButton } from '@/presentation/components/Schedule/components/CourseDetail';
import { ArticuleBlock } from '../styles';

interface PropsPdf {
  onClose: () => void;
  name: string;
  filePdf: string;
}

const VisualizerPDF = ({ onClose, name, filePdf }: PropsPdf) => (
  <ArticuleBlock data-testid="cmp-visualizer">
    <Block>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <h1
          style={{
            marginTop: 24,
            padding: 16,
            color: '#161D1F',
            fontFamily: 'Lato',
            fontSize: 20,
            fontWeight: 900
          }}
        >
          {name ?? 'Vista previa del PDF'}
        </h1>
        <GoToButton
          padding="8px"
          margin="8px"
          buttonType="close"
          onClick={onClose}
        >
          <Icon name="x" size={22} />
        </GoToButton>
      </div>
      <iframe
        src={`${process.env.REACT_APP_PREFIX_PDF}/${filePdf}`}
        style={{
          width: '100%',
          height: '90vh',
          border: 'none',
          padding: 16
        }}
        title="PDF Viewer"
      />
    </Block>
  </ArticuleBlock>
);

export default VisualizerPDF;
